import { HeaderContainer } from "../InfoStyled";
import { ReactComponent as CloseSVG } from "../assets/icons/info_close.svg";

export default function Header({ close }) {
  return (
    <HeaderContainer>
      <h2 className="title">GAME INFO</h2>
      <div className="icon" onClick={() => close()}>
        <CloseSVG className="close-btn" />
      </div>
    </HeaderContainer>
  );
}
